import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1302PersontypAendernStatus: 'idle',
    startProcess1302PersontypAendernError: undefined as any,
    loadUserParamsProcess1302PersontypAendernStatus: 'idle',
    loadUserParamsProcess1302PersontypAendernError: undefined as any,

    process1302PersontypAendernList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1302PersontypAendern = createAsyncThunk('process1302PersontypAendernSlice/startProcess1302PersontypAendern', async ({ process1302PersontypAendern }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1302PersontypAendern/`,
        prepareData(process1302PersontypAendern),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1302PersontypAendernStatus } = getState().process1302PersontypAendernSlice
        return startProcess1302PersontypAendernStatus !== 'pending'
    }
})

export const loadUserParamsProcess1302PersontypAendern = createAsyncThunk('process1302PersontypAendernSlice/loadUserParamsProcess1302PersontypAendern', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1302PersontypAendern/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1302PersontypAendernStatus } = getState().process1302PersontypAendernSlice
        return loadUserParamsProcess1302PersontypAendernStatus !== 'pending'
    }
})

const Process1302PersontypAendernSlice = createSlice({
    name: 'process1302PersontypAendernSlice',
    initialState,
    reducers: {
        resetstartProcess1302PersontypAendern: (state) => {
            state.job = undefined
            state.startProcess1302PersontypAendernError = undefined
        },
        resetstartProcess1302PersontypAendernError: (state) => {
            state.startProcess1302PersontypAendernError = undefined
        },
        resetloadUserParamsProcess1302PersontypAendern: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1302PersontypAendernError = undefined
        },
        resetloadUserParamsProcess1302PersontypAendernError: (state) => {
            state.loadUserParamsProcess1302PersontypAendernError = undefined
        },
        removeFromProcess1302PersontypAendernListById: (state, action) => {
            state.process1302PersontypAendernList = state.process1302PersontypAendernList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1302PersontypAendernListByIds: (state, action) => {
            state.process1302PersontypAendernList = state.process1302PersontypAendernList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1302PersontypAendernList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1302PersontypAendernStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1302PersontypAendernList = []
            state.startProcess1302PersontypAendernStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1302PersontypAendern.pending, (state) => {
            state.startProcess1302PersontypAendernStatus = 'pending'
            state.startProcess1302PersontypAendernError = undefined
        })
        builder.addCase(startProcess1302PersontypAendern.fulfilled, (state, action) => {
            state.startProcess1302PersontypAendernStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1302PersontypAendern.rejected, (state, action) => {
            state.startProcess1302PersontypAendernStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1302PersontypAendernError = action.error.message
            } else {
                state.startProcess1302PersontypAendernError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1302PersontypAendern.pending, (state) => {
            state.loadUserParamsProcess1302PersontypAendernStatus = 'pending'
            state.loadUserParamsProcess1302PersontypAendernError = undefined
        })
        builder.addCase(loadUserParamsProcess1302PersontypAendern.fulfilled, (state, action) => {
            state.loadUserParamsProcess1302PersontypAendernStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1302PersontypAendern.rejected, (state, action) => {
            state.loadUserParamsProcess1302PersontypAendernStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1302PersontypAendernError = action.error.message
            } else {
                state.loadUserParamsProcess1302PersontypAendernError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1302PersontypAendern,
    resetstartProcess1302PersontypAendernError,
    resetloadUserParamsProcess1302PersontypAendern,
    resetloadUserParamsProcess1302PersontypAendernError,
    removeFromProcess1302PersontypAendernListById,
    removeFromProcess1302PersontypAendernListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1302PersontypAendernSlice.actions
export default Process1302PersontypAendernSlice.reducer
